"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _getComponentName = _interopRequireDefault(require("react-utils/getComponentName"));

var _isFileManagerUrl = _interopRequireDefault(require("FileManagerLib/utils/isFileManagerUrl"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _hubl = require("../../utils/hubl");

var _makeCancelable = require("../../utils/makeCancelable");

var _link = require("../../utils/link");

var _iterables = require("../../utils/iterables");

var _link2 = require("../../constants/link");

var _usageTracking = require("../../constants/usageTracking");

var _anchor = require("../../utils/anchor");

/**
 * @TODO Remove `useExplicitSave` alternative logic once `useContextualToolbar`
 * is fully ungated since everything will be explicit save
 */
var withLinkState = function withLinkState(WrappedComponent) {
  var ManagedLinks = /*#__PURE__*/function (_Component) {
    (0, _inherits2.default)(ManagedLinks, _Component);

    function ManagedLinks(props) {
      var _this;

      (0, _classCallCheck2.default)(this, ManagedLinks);
      _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(ManagedLinks).call(this, props));

      _this.handleUpdate = function (update) {
        var updateSource = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

        // Update Popover State
        _this.setState(Object.assign({}, update), function () {
          if (!_this.initialLinkInfo) {
            _this.initialLinkInfo = _this.state;
          }

          var hasValidValue = _this.state.href || _this.state.fileMeta; // Store this fully updated link state

          if (hasValidValue) {
            _this.lastCompleteLinkState = _this.state;
          }

          if (_link2.CacheableLinkTypes.includes(_this.state.linkType) && _this.state.href) {
            _this.props.updateCache(_this.state.href, (0, _iterables.pick)(_link2.CacheableLinkFields, _this.state));
          }

          if (updateSource && hasValidValue && !_this.props.useExplicitSave) {
            // Update source state with new state
            _this.props.onUpdate(_this.state);
          }
        });
      };

      _this.handleSave = function () {
        if (_this.props.useExplicitSave) {
          var _this$props;

          for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }

          (_this$props = _this.props).onSave.apply(_this$props, [_this.state].concat(args));

          _this.lastSavedLinkState = Object.assign({}, _this.state, {
            isValidLink: true
          });

          _this.trackLinkUsage();
        }
      };

      _this.handleLinkTypeChange = function (linkType) {
        _this.setState({
          linkType: linkType,
          href: '',
          fileMeta: null,
          externalLink: _link2.ExternalLinkTypes.includes(linkType),
          isValidLink: true
        });

        if (_this.props.onLinkTypeChange && !_this.props.useExplicitSave) {
          _this.props.onLinkTypeChange(linkType);
        }
      };

      _this.handleUnlink = function () {
        _this.setState({
          linkType: _link2.LinkTypes.NONE,
          href: '',
          fileMeta: null,
          isValidLink: true
        }, _this.handleSave);
      };

      _this.handleClose = function () {
        var _this$props2 = _this.props,
            useExplicitSave = _this$props2.useExplicitSave,
            onClose = _this$props2.onClose;

        if (useExplicitSave) {
          _this.setState(Object.assign({}, _this.lastSavedLinkState || _this.initialLinkInfo));
        } else {
          var hasValidValue = _this.state.href || _this.state.fileMeta;

          if (!hasValidValue && _this.state.linkType !== _link2.LinkTypes.NONE) {
            // Restore the link state since it was only partially updated
            _this.setState(Object.assign({}, _this.lastCompleteLinkState));
          }
        }

        if (onClose) onClose();
      };

      var linkText = props.linkText,
          href = props.href,
          noFollow = props.noFollow,
          relAttr = props.relAttr,
          externalLink = props.externalLink;
      _this.state = {
        linkText: linkText,
        href: href,
        noFollow: noFollow,
        relAttr: relAttr,
        externalLink: externalLink,
        linkType: _link2.LinkTypes.URL,
        linkDisplayName: href,
        isValidLink: true
      };
      return _this;
    }

    (0, _createClass2.default)(ManagedLinks, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        this.fetchLinkType();
      }
    }, {
      key: "componentDidUpdate",
      value: function componentDidUpdate(_ref) {
        var prevMode = _ref.mode;
        var _this$props3 = this.props,
            useExplicitSave = _this$props3.useExplicitSave,
            mode = _this$props3.mode,
            linkText = _this$props3.linkText;

        if (useExplicitSave && prevMode !== mode) {
          // Restore link state to last completed
          this.setState(Object.assign({}, this.lastSavedLinkState || this.initialLinkInfo, {
            linkText: linkText
          }));
        }
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        this.linkTypePromise.cancel(); // Race condition with page fetching and state updating etc

        if (!this.props.useExplicitSave && this.initialLinkInfo) {
          this.trackLinkUsage();
        }
      }
    }, {
      key: "trackLinkUsage",
      value: function trackLinkUsage() {
        if (!this.props.trackLinkUsage) return; // We want to track changes to href but not the href value itself

        var pickTrackingChangeValues = (0, _iterables.pick)([].concat((0, _toConsumableArray2.default)(_link2.TrackableLinkFields), ['href']));
        var initialTrackingValues = pickTrackingChangeValues(this.initialLinkInfo);

        var _trackingValues = pickTrackingChangeValues(this.state);

        if (!(0, _iterables.deepCompare)(_trackingValues, initialTrackingValues)) {
          var trackingAction = initialTrackingValues.linkType === _link2.LinkTypes.NONE ? _usageTracking.INSERT_LINK : _usageTracking.UPDATE_LINK;
          var __href = _trackingValues.href,
              noFollow = _trackingValues.noFollow,
              relAttr = _trackingValues.relAttr,
              trackingValues = (0, _objectWithoutProperties2.default)(_trackingValues, ["href", "noFollow", "relAttr"]);

          if (!this.props.useContextualToolbar) {
            // Convert legacy `noFollow` value to `nofollow`
            trackingValues.nofollow = noFollow;
          }

          this.props.trackLinkUsage(trackingAction, Object.assign({}, trackingValues, {}, (0, _link.getRelAttrTrackingValues)(relAttr)));
        }
      }
    }, {
      key: "checkForFileLink",
      value: function checkForFileLink(href) {
        var _this$props4 = this.props,
            fetchFileFromUrl = _this$props4.fetchFileFromUrl,
            fetchFileByUrl = _this$props4.fetchFileByUrl;

        var getLinkInfo = function getLinkInfo(fileData) {
          return {
            linkType: _link2.LinkTypes.FILE,
            linkDisplayName: fileData.title + "." + fileData.extension,
            fileMeta: {
              fileName: fileData.title + "." + fileData.extension,
              size: fileData.size,
              type: fileData.type
            }
          };
        };

        if (fetchFileByUrl) {
          return new Promise(function (resolve, reject) {
            fetchFileByUrl(href).then(function (fileData) {
              return resolve(getLinkInfo(fileData));
            }).catch(reject);
          });
        }

        return new Promise(function (resolve, reject) {
          fetchFileFromUrl(encodeURIComponent(href)).then(function (fileData) {
            return resolve(getLinkInfo(fileData));
          }).catch(reject);
        });
      }
    }, {
      key: "checkForPageUrl",
      value: function checkForPageUrl(href) {
        var _this2 = this;

        var fetchPageBySlug = this.props.fetchPageBySlug;

        var _getUrlParts = (0, _link.getUrlParts)(href),
            slug = _getUrlParts.slug;

        return new Promise(function (resolve, reject) {
          fetchPageBySlug(slug).then(function (_ref2) {
            var pages = _ref2.objects;
            var matchingPage = pages.find(function (_ref3) {
              var url = _ref3.url;
              return (0, _link.comparePageURLs)(href, url);
            });

            if (matchingPage) {
              resolve({
                linkType: _link2.LinkTypes.PAGE,
                linkDisplayName: matchingPage.name
              });
            } else {
              resolve(_this2.getExternalUrl(href));
            }
          }).catch(reject);
        });
      }
    }, {
      key: "checkForMeetingLink",
      value: function checkForMeetingLink(href) {
        var _this3 = this;

        var fetchMeetingBySlug = this.props.fetchMeetingBySlug;
        var slug = (0, _link.getMeetingLinkSlug)(href);
        return new Promise(function (resolve, reject) {
          fetchMeetingBySlug(slug).then(function (meeting) {
            if (meeting.link === href) {
              resolve({
                linkType: _link2.LinkTypes.MEETING,
                linkDisplayName: meeting.name || meeting.link
              });
            } else {
              resolve(_this3.getExternalUrl(href));
            }
          }).catch(reject);
        });
      }
    }, {
      key: "checkForAnchorLink",
      value: function checkForAnchorLink(href) {
        var _this4 = this;

        var anchorName = (0, _anchor.deserializeAnchorFromLink)(href);
        return new Promise(function (resolve, reject) {
          _this4.props.fetchAnchors(anchorName, true) // Pass in `true` for an exact match
          .then(function (anchors) {
            if (anchors.length) {
              resolve({
                linkType: _link2.LinkTypes.ANCHOR,
                linkDisplayName: anchorName
              });
            } else {
              resolve(_this4.getExternalUrl(href));
            }
          }).catch(reject);
        });
      }
    }, {
      key: "getExternalUrl",
      value: function getExternalUrl(href) {
        return {
          linkType: _link2.LinkTypes.URL,
          linkDisplayName: href
        };
      }
    }, {
      key: "fetchLinkType",
      value: function fetchLinkType() {
        var _this5 = this;

        var _this$props5 = this.props,
            href = _this$props5.href,
            cache = _this$props5.cache,
            useNoLinkOption = _this$props5.useNoLinkOption,
            insertLink = _this$props5.insertLink,
            allowMeetingLink = _this$props5.allowMeetingLink,
            allowAnchorLinks = _this$props5.allowAnchorLinks,
            allowFileDownload = _this$props5.allowFileDownload,
            allowPageLinks = _this$props5.allowPageLinks;
        this.linkTypePromise = (0, _makeCancelable.makeCancelable)(new Promise(function (resolve, reject) {
          if (cache[href]) {
            resolve((0, _iterables.pick)(_link2.CacheableLinkFields, cache[href]));
          } else if (!href) {
            if (useNoLinkOption && !insertLink) {
              resolve({
                linkType: _link2.LinkTypes.NONE,
                linkDisplayName: ''
              });
            } else {
              resolve(_this5.getExternalUrl(href));
            }
          } else if (href.startsWith('mailto:')) {
            resolve({
              linkType: _link2.LinkTypes.EMAIL,
              linkDisplayName: href.split('mailto:')[1]
            });
          } else if (allowAnchorLinks && href.startsWith('#')) {
            _this5.checkForAnchorLink(href).then(resolve).catch(reject);
          } else if ((0, _hubl.getHublVariable)(href)) {
            if ((0, _hubl.getEmailSystemHublVar)(href)) {
              resolve({
                linkType: _link2.LinkTypes.EMAIL_SUBSCRIPTION,
                linkDisplayName: (0, _hubl.getEmailSubscriptionLinkDisplayName)(href)
              });
            } else {
              resolve(_this5.getExternalUrl(href));
            }
          } else if ((0, _hubl.hasHublVariable)(href)) {
            resolve(_this5.getExternalUrl(href));
          } else if (allowFileDownload && (0, _isFileManagerUrl.default)(href)) {
            _this5.checkForFileLink(href).then(resolve).catch(function () {
              if (allowPageLinks) {
                _this5.checkForPageUrl(href).then(resolve).catch(reject);
              } else {
                resolve(_this5.getExternalUrl(href));
              }
            });
          } else if (allowMeetingLink && (0, _link.isMeetingLink)(href)) {
            _this5.checkForMeetingLink(href).then(resolve).catch(reject);
          } else if (allowPageLinks) {
            _this5.checkForPageUrl(href).then(resolve).catch(reject);
          } else {
            resolve(_this5.getExternalUrl(href));
          }
        }));
        this.linkTypePromise.promise.then(function (data) {
          _this5.handleUpdate(data, false);
        }).catch(function (error) {
          if (error.isCanceled) {
            console.warn('linkType fetch cancelled in `withLinkState`');
          } else {
            // Throw a new error so sentries can log API failures and we
            // can trace it back to `withLinkState`
            throw new Error(error.message);
          }
        });
      }
    }, {
      key: "render",
      value: function render() {
        var _this$state = this.state,
            fileMeta = _this$state.fileMeta,
            linkData = (0, _objectWithoutProperties2.default)(_this$state, ["fileMeta"]);
        return _react.default.createElement(WrappedComponent, Object.assign({}, this.props, {
          onLinkTypeChange: this.handleLinkTypeChange,
          onUpdate: this.handleUpdate,
          onSave: this.handleSave,
          onUnlink: this.handleUnlink,
          dropdownClassName: this.props.dropdownClassName,
          showRefAndTargetControls: this.props.showRefAndTargetControls,
          fetchPages: this.props.fetchPages,
          onSelectFile: this.props.onSelectFile,
          onClose: this.handleClose,
          currentFileMeta: fileMeta
        }, linkData));
      }
    }]);
    return ManagedLinks;
  }(_react.Component);

  ManagedLinks.propTypes = {
    fetchPageBySlug: _propTypes.default.func.isRequired,
    fetchMeetingBySlug: _propTypes.default.func.isRequired,
    updateCache: _propTypes.default.func.isRequired,
    trackLinkUsage: _propTypes.default.func,
    cache: _propTypes.default.object.isRequired,
    onUpdate: _propTypes.default.func,
    onSave: _propTypes.default.func,
    onClose: _propTypes.default.func,
    onLinkTypeChange: _propTypes.default.func,
    linkText: _propTypes.default.string,
    href: _propTypes.default.string,
    noFollow: _propTypes.default.bool,
    relAttr: _propTypes.default.array,
    externalLink: _propTypes.default.bool,
    showRefAndTargetControls: _propTypes.default.bool,
    fetchFileFromUrl: _propTypes.default.func,
    fetchFileByUrl: _propTypes.default.func,
    fetchPages: _propTypes.default.func,
    fetchAnchors: _propTypes.default.func,
    onSelectFile: _propTypes.default.func,
    dropdownClassName: _propTypes.default.string,
    useNoLinkOption: _propTypes.default.bool,
    insertLink: _propTypes.default.bool,
    mode: _propTypes.default.string,
    allowMeetingLink: _propTypes.default.bool,
    allowAnchorLinks: _propTypes.default.bool,
    allowFileDownload: _propTypes.default.bool,
    allowPageLinks: _propTypes.default.bool,
    useExplicitSave: _propTypes.default.bool,
    useContextualToolbar: _propTypes.default.bool
  };
  ManagedLinks.defaultProps = {
    cache: {}
  };
  ManagedLinks.displayName = "withLinkState(" + (0, _getComponentName.default)(WrappedComponent) + ")";
  return ManagedLinks;
};

var _default = withLinkState;
exports.default = _default;
module.exports = exports.default;